module.exports = __webpack_public_path__ + "img/02.3793d297.png";